import React, { useEffect, useState } from 'react';
import { useAppNavigate } from '../../hooks/useAppNavigate';
import Header from "../../containers/Header";
import MeetingSDK from '../../components/MeetingSDK';
import './styles.css';
import { usePodData } from '../../hooks/usePodData';
import { useLocalization } from '../../context/LocalizationContext';
import { sendConsultationEmails } from '../../utils/api';
import { useUserData } from '../../hooks/useUserData';
import { useAppContext } from '../../context/AppContext';

import { UserData } from '../../dtos/patient';

interface ConsultationProps {
  userData?: UserData;
}

const Consultation: React.FC<ConsultationProps> = ({ userData }) => {
  const navigate = useAppNavigate();
  const { podData, podIP } = usePodData();
  const { t } = useLocalization();
  const [emailsSent, setEmailsSent] = useState(false);
  const [isEndingMeeting, setIsEndingMeeting] = useState(false);
  const { userData: userDataFromHook } = useUserData();
  const { markStepCompleted } = useAppContext();


  useEffect(() => {
    markStepCompleted("consultation");
  }, []);

  const handleCallError = (error: any) => {
    console.error('MeetingSDK error:', error);
  };

  const handleMeetingJoined = async () => {
    if (!emailsSent && userDataFromHook?.patientId && podIP) {
      try {
        await sendConsultationEmails(podIP, userDataFromHook.patientId);
        setEmailsSent(true);
      } catch (error) {
        // console.error('Failed to send consultation emails:', error);
      }
    }
  };

  const handleEndMeeting = async () => {
    setIsEndingMeeting(true);
    navigate("/dashboard");
  };

  return (
    <div className="page-container consultation-page page-scrollable">
      <Header
        title={t('consultation.title')}
        statusText={t('consultation.liveSession')}
        statusType="danger"
        showHomeButton={true}
        showSettingsButton={true}
      />

      <div className="consultation-video-container">
 


        {!isEndingMeeting && podData?.meetingLink && (
          <MeetingSDK
            roomUrl={podData?.meetingLink}
            onError={handleCallError}
            onJoined={handleMeetingJoined}
            onCallEnd={handleEndMeeting}
            userData={userData}
            onLoadingStateChange={(isLoading) => {
              const pageContainer = document.querySelector('.consultation-page');
              if (pageContainer) {
                if (isLoading) {
                  pageContainer.classList.add('loading');
                } else {
                  pageContainer.classList.remove('loading');
                }
              }
            }}
          />
        )}
      </div>
    </div>
  );
};

export default Consultation;
